import {
  AddJobsIcon,
  AllJobIcon,
  AllPostJobIcon,
  ContactUsIcon,
  LogoutIcon,
  PostJobIcon,
  ProfileIcon,
  SaveForLaterIcon,
  StatIcon,
} from "./assets/icons/icons";

export const sideBarData = [
  {
    id: 1,
    icon: <StatIcon />,
    navName: "Stats",
    link: "",
  },
  {
    id: 2,
    icon: <AddJobsIcon />,
    navName: "Add Job",
    link: "/add-job",
  },
  {
    id: 3,
    icon: <AllJobIcon />,
    navName: "All Jobs",
    link: "/all-jobs",
  },
  {
    id: 4,
    icon: <ProfileIcon />,
    navName: "Profile",
    link: "/profile",
  },
  {
    id: 5,
    icon: <PostJobIcon />,
    navName: "Post Job",
    link: "/post-job",
  },
  {
    id: 6,
    icon: <AllPostJobIcon />,
    navName: "View Job Posts",
    link: "/all-post-jobs",
  },
  {
    id: 7,
    icon: <SaveForLaterIcon />,
    navName: "Saved For Later",
    link: "/save-for-later",
  },
  {
    id: 8,
    icon: <ContactUsIcon />,
    navName: "Contact Us",
    link: "/contact",
  },
  {
    id: 9,
    icon: <LogoutIcon />,
    navName: "Logout",
    link: "logout",
  },
];
